module.exports = __webpack_public_path__ + "static/media/check.7b9cde8f.svg";